import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ImpersonationHandoffModel } from "services/api/cplauthapi/CPLAuthAPI";
import { IImpersonationService } from "services/ImpersonationService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

type ImpersonationState = {
  ImpersonationToken: ImpersonationHandoffModel | undefined;
};

const initialState: ImpersonationState = {
  ImpersonationToken: undefined,
};

export const impersonationSlice = createSlice({
  name: "impersonation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getImpersonationToken.pending, (state) => {
        state.ImpersonationToken = undefined;
      })
      .addCase(getImpersonationToken.rejected, (state) => {
        state.ImpersonationToken = undefined;
      })
      .addCase(getImpersonationToken.fulfilled, (state, action) => {
        state.ImpersonationToken = action.payload;
      });
  },
});

export const getImpersonationToken = createAsyncThunk(
  "impersonation/GetImpersonationToken",
  async (clientPortalUserID: string) => {
    const impersonationService = container.get<IImpersonationService>(SERVICE_TYPES.ImpersonationService);
    return await impersonationService.getImpersonationToken(clientPortalUserID);
  }
);

export const selectImpersonationToken = (state: RootState) => state.impersonation.ImpersonationToken;
export const selectURL = (state: RootState) => state.impersonation.ImpersonationToken?.clientPortalURL;

export default impersonationSlice.reducer;
